import React, { useState } from 'react';
import NavBar from '../components/NavBar';
import Petrochemical from '../components/Petrochemical';
import Two from '../components/Two';

const hotspots = require('../data/petrohotspots.json');

const Home = () => {
    //States
    //--------------------------------------------------------------------------------------------------------------
    //hotspot selection:
    const [selection, setSelection] = useState(0);

    //menu data: Add elements as needed
    const [menuSelection, setMenuSelection] = useState(1);
    const [data, setData] = useState([
        {
            id: 1,
            name: "petrochemical",
            active: "active",
            location: "",
            style: {cursor: 'pointer', width: "20%"}
        }
    ]);
    

    //Actions
    //--------------------------------------------------------------------------------------------------------------
    //menu selection
    const handleMenuSelection = (id) => {
        //set menu selection:
        // console.log("Selection ",id);
        setMenuSelection(id);
        data.map((n) => {
            if (id === n.id) {
                return n.active = "active";
            } else {
                return n.active = "";
            }
        });
        setData(data);

        //reset hotspot selection:
        setSelection(0);
    };

    //hotspot selection
    const handleSelection = (id) => {
        var h = null;
        
        // console.log("Selection ",id);
        setSelection(id);

        //loop through all the others and de-activate them
        hotspots.forEach((hotspot) => {
            h = document.getElementById(`${hotspot.id}`);
            if (hotspot.id !== id) {
                h.classList.remove('active');
            } else {
                h.classList.add('active');
            }
        });
    };


    return (
        <main className="main">
            <div className="tool-title">
                <h3>Corrosion &amp; Erosion Solution Advisor</h3>
            </div>
            <div className="navbar-wrapper">
                <NavBar navdata={data} handleMenuSelection={handleMenuSelection} />
                
            </div>
        
            { menuSelection === 1 ? 
                <>
                    <Petrochemical key={menuSelection} selection={selection} handleSelection={handleSelection} />
                    {/* <Grid item xs={12}>
                        <p className="legal-disclaimer">
                            <span style={{ fontWeight: 'bold', fontSize: '10px' }}>Disclaimer:</span><br />
                            {disclaimer}
                        </p>
                    </Grid> */}
                </>
            : menuSelection === 2 &&
                <>
                    <Two key={menuSelection} selection={selection} handleSelection={handleSelection} />
                    {/* <Grid item xs={12}>
                        <p className="legal-disclaimer">
                            <span style={{ fontWeight: 'bold', fontSize: '10px' }}>Disclaimer:</span><br />
                            {disclaimer}
                        </p>
                    </Grid> */}
                </>
            }
            
        </main>
    )
}

export default Home;